import * as React from "react";
import logo from "./w-logo.png";

export const WartsilaLogoWithoutLink: React.FC = () => <img src={logo} alt="Wärtsilä Logo" />;
